export const GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
export const GET_COURSES_FAIL = 'GET_COURSES_FAIL';
export const SET_COURSES_FILTER = 'SET_COURSES_FILTER';
export const DELETE_COURSE = 'DELETE_COURSE';
export const SET_FETCHING_COURSES = 'SET_FETCHING_COURSES';